module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Win1894_C.1a522d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Win1894_C.png
// module id = 422
// module chunks = 0